module.exports = __webpack_public_path__ + "static/img/COC2023-6.705e43a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-6.png
// module id = vUkw
// module chunks = 0